import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { schemaTemplatesMailSignature } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};

export const schemaTemplateResolver_GetSignature = schemaTemplatesMailSignature
    .pick({
        createdAt: true,
        data: true,
        id: true,
        name: true,
        type: true,
        users: true,
    })
    .nullable();

export type SchemaTemplateResolver_GetSignature = z.infer<typeof schemaTemplateResolver_GetSignature>;

export type TemplateResolver_GetSignature = Resolver<Arguments, SchemaTemplateResolver_GetSignature>;
